import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMonthlyEarningTable(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/dashboard/monthly-earning-table', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMonthlyStockTable(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/dashboard/monthly-stock-table', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStockReport(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/reports/stock-report', { params: data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
